import { jsonldEndTime } from './JsonldStore';

export const updateJsonldEndTime = (value) => jsonldEndTime.update((oldValue) => value);
